module.exports = __webpack_public_path__ + "static/media/MenuSept2025.bb920341.pdf";